module.exports = __webpack_public_path__ + "img/Turn_logo.7c81ade9.png";